export const ROUTES = {
  HOME: '/',
  DISCOVER: '/discover',
  DASHBOARD: '/dashboard',
  SUBSCRIBE: '/subscribe',
  SUBSCRIBE_PLAN: '/subscribe/:planId',
  LOGIN: '/login',
  LOGIN_2FA: '/login/2fa',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD_VERIFY: '/reset-password/verify',
  RESET_PASSWORD_SET: '/reset-password/set',
  ACCOUNT_CREATED: '/account-created',
  VERIFY_EMAIL: '/verify-email',
  PAYMENT_SUCCESS: '/payment-success',
  CUSTOM_OFFER_FORM: '/custom-offer-form',
  SEATS: '/seats',
  SEATS_ADD: '/seats/add',
  FAQ: '/faq',
  ENABLE_2FA: '/dashboard/2fa/enable',
  CGU: '/cgu',
} as const

export const PUBLIC_PATHS: readonly string[] = [
  ROUTES.HOME,
  ROUTES.DISCOVER,
  ROUTES.LOGIN,
  ROUTES.LOGIN_2FA,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD_VERIFY,
  ROUTES.RESET_PASSWORD_SET,
  ROUTES.SUBSCRIBE,
  ROUTES.ACCOUNT_CREATED,
  ROUTES.VERIFY_EMAIL,
  ROUTES.PAYMENT_SUCCESS,
  ROUTES.CUSTOM_OFFER_FORM,
  ROUTES.FAQ,
  ROUTES.CGU,
] as const
